import {connect} from 'react-redux';
import { setSidebar } from '../../../redux/ui/actions';
import { useStyles } from '../styles';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import TopBarMenu from './TopbarMenu';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import constants from '../../../globals/platform-constants/index';
const Topbar = (props) => {
    const { minimal, setSidebar, sidebar } = props;
    const classes = useStyles();

    function handleDrawerOpen() {
        setSidebar(true, true);
    }

    return (
        <div className={classes.root}>
            <AppBar
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: sidebar,
                })}
                position="fixed"
            >
                <Toolbar className={classes.toolbar}>
                    {!minimal && !sidebar && (
                        <IconButton
                            aria-label="Open drawer"
                            className={clsx(classes.menuButton, sidebar && classes.menuButtonHidden)}
                            color="inherit"
                            data-cy="SidebarOpen"
                            edge="start"
                            onClick={handleDrawerOpen}
                        >
                            <KeyboardArrowRightIcon />
                        </IconButton>
                    )}

                    <Typography className={classes.title} color="inherit" component="h1" noWrap variant="h6">
                        Command Center {constants.VERSION}
                    </Typography>

                    <TopBarMenu />
                </Toolbar>
            </AppBar>
        </div>
    );
};

//TODO remove the following and swap for hooks
const mapStateToProps = (state, ownProps) => ({
    sidebar: state.ui.sidebar,
});

const mapDispatchToProps = dispatch => {
    return {
        setSidebar: (status, clicked) => dispatch(setSidebar(status, clicked)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Topbar);
